var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 13 74 74",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block",
      shapeRendering: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85 50 A35 35 0 0 1 15 50.00000000000001",
    fill: "none",
    stroke: "#0a0a0a",
    strokeWidth: 1,
    style: {
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 50.00000000000001 A35 35 0 0 1 85 49.99999999999999",
    fill: "none",
    strokeWidth: 1,
    style: {
      strokeLinecap: "round",
      stroke: "rgb(172, 172, 172)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.452 67.604 C 32.452 40.661 61.619 23.821 84.952 37.293 C 95.781 43.545 102.452 55.099 102.452 67.604",
    fill: "none",
    strokeWidth: 1,
    transform: "matrix(0, 1, -1, 0, 117.529739, -17.37426)",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.17721a8bd498c83c66f4c3aa166c427b.svg";
export { ForwardRef as ReactComponent };